import { useEffect, useState } from 'react';

import styles from './ThankYouInner.module.scss';

type RatingProps = {
  rating: number;
};

export const ThankYouInner = ({ rating }: RatingProps) => {
  return (
    <div className={styles.container}>
      <img
        className={styles.img}
        src='/images/illustration-thank-you.svg'
        alt='thank you'
      />
      <div className={styles['rating-info']}>
        You selected {rating} out of 5
      </div>
      <h1 className={styles.header}>Thank you!</h1>
      <p className={styles.text}>
        We appreciate you taking the time to give a rating. If you ever need
        more support, don't hesitate to get in touch!
      </p>
    </div>
  );
};
